import {useState} from "react";
import {useTranslation} from "react-i18next";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {tDarCodeName} from "../lib/dar-code-i18n";
import {DailyActivityReportCode} from "../types";

type DarCodeComboboxProps = {
  value: DailyActivityReportCode | null;
  onChange: (value: DailyActivityReportCode | null) => void;
};

export function DarCodeCombobox({value, onChange}: DarCodeComboboxProps) {
  const {t} = useTranslation("dar");
  const [dailyActivityReportCodes] = useState<DailyActivityReportCode[]>(
    getStorageItem("dailyActivityReportCodes"),
  );

  return (
    <ComboboxGeneric<DailyActivityReportCode>
      items={dailyActivityReportCodes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `dar-code-${item.daily_activity_report_code_id}`}
      getItemLabel={(item) => tDarCodeName(item.type, t)}
      isItemEqual={(item, selected) =>
        item.daily_activity_report_code_id === selected?.daily_activity_report_code_id
      }
      placeholder={t("select_code")}
      emptyMessage="No items found."
    />
  );
}
